<template>
  <div class="bottom-foot">
      <div class="foots">
        <div class="top"><img src="./images/top.jpg" alt=""  @click="backTop()" oncontextmenu="return false;" onselectstart="return false;"></div>
        <div class="up">
            <div class="middle">
                <div class="left">
                    <p>联系我们</p>
                    <p>CONTACT US</p>
                    <ul class="navs">
                        <li>业务洽谈：<a class="tel" v-text="d555"></a>&nbsp;&nbsp;&nbsp;投诉建议：<a class="tel">18027103455</a></li>
                        <li>售后服务：<a class="tel">400-900-5939</a></li>
                        <li></li>
                        <li>联系邮箱：marketing@weimaqi.com</li>
                        <li>公司地址：广州市番禺区南村镇鸿创直街19号五楼(番禺工业经济总部园区禹能集团总部大楼五楼)</li>
                    </ul>
                </div>
                <div class="right">
                    <div class="ewm" >
                        <img src="./images/erweima.jpg" alt="" oncontextmenu="return false;" onselectstart="return false;">
                    </div>
                    <ul class="icons">
                        <li><img src="../../assets/fivep/wechat.svg" oncontextmenu="return false;" onselectstart="return false;"></li>
                        <li><img src="../../assets/fivep/QQ.svg" oncontextmenu="return false;" onselectstart="return false;"></li>
                        <li>
                            <div class="liphone">
                                <div class="liph">商务合作电话</div>
                                <span class="liph1">400-900-5939</span>
                              </div>
                            <img src="../../assets/fivep/phone.svg" oncontextmenu="return false;" onselectstart="return false;">
                        </li>
                    </ul>
                    
                </div>
            </div>
        </div>
        <div class="phone-up">
            <div class="middle">
                <div class="left">
                    <p>联系我们</p>
                    <p>CONTACT US</p>
                    <ul class="navs">
                        <li>业务洽谈：<a class="tel10" v-text='d666'></a>&nbsp;&nbsp;投诉建议：<a>18027103455</a></li>
                        <li>售后服务：<a>400-900-5939</a></li>
                    </ul>
                </div>
                <div class="ewm"><img src="./images/erweima.jpg" alt="" ></div>
            </div>
            <div class="longline"></div>
            <div class="bot">
                    <p>联系邮箱：marketing@weimaqi.com</p>
                    <p>公司地址：广州市番禺区南村镇鸿创直街19号五楼(番禺工业经济总部园区禹能集团总部大楼五楼)</p>
            </div>
        </div>
        <div class="down">
            <div class="foot">
                <div class="copyright" >Copyright © 广州扬盛计算机软件 版权所有　粤ICP备15073043号</div>
                <nav>
                    <ul class="nav">
                        <li @click="totop1()"> <router-link  to="/home" >首页</router-link><img src="../../assets/rightline.png"></li>
                        <li @click="totop1()"> <router-link  to="/hard" >硬件产品</router-link><img src="../../assets/rightline.png"></li>
                        <li @click="totop1()"> <router-link  to="/software" >软件服务</router-link><img src="../../assets/rightline.png"></li>
                        <li @click="totop1()" class="books"> 
                        <div class="book"><router-link to="">产品手册</router-link><i class="fa fa-caret-up"></i><img src="../../assets/rightline.png"></div>
                        <ul class="dropdown-menu">
                            <div class="dropdown-left">
                            <li class="dropdown-header">使用者</li>
                            <li><a href="https://www.weimaqi.net/www/2016/product.aspx" target="_blank">产品介绍</a></li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial_buycoin.aspx" target="_blank">购币流程</a></li>
                            <li class="divider"></li>
                            <li class="dropdown-header">安装人员</li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial_hw_setup_video.aspx" target="_blank">维码器安装视频</a></li>
                            <li><a href="http://q.eqxiu.com/s/OYJFir7B" target="_blank">线上手册</a></li>
                            <li><a href="http://q.eqxiu.com/s/OYJFir7B" target="_blank">手册下载</a></li>
                            <li><a href="https://www.weimaqi.net/www/2016/download/wmq_user_manual.pdf" target="_blank">操作指南下载</a></li>
                            <li class="divider"></li>
                            <li class="dropdown-header">商家/代理</li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial_mch_register_video.aspx" target="_blank">自助注册教程</a></li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial/mch/alipay_apply/zhifubao.html" target="_blank">支付宝  申请流程</a></li>
                            </div>
                            <div class="dropdown-right">
                            <li class="dropdown-header">收款设置</li>
                            <li><a href="https://weimaqi.oss-cn-shenzhen.aliyuncs.com/%E8%B5%84%E6%96%99/%E5%BE%AE%E4%BF%A1%E5%85%AC%E4%BC%97%E5%8F%B7%E6%94%B6%E6%AC%BE%E7%BB%86%E5%88%99.pdf" target="_blank">微信公众号</a></li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial/manual/payment/zishanghu.html" target="_blank">微信子商户</a></li>
                            <li><a href="https://www.weimaqi.net/www/2016/tutorial/manual/payment/zhifubaoshoukuan.html" target="_blank">企业支付宝</a></li>
                            <li><a href="https://weimaqi.oss-cn-shenzhen.aliyuncs.com/%E8%B5%84%E6%96%99/%E6%94%AF%E4%BB%98%E5%AE%9D%E5%BD%93%E9%9D%A2%E4%BB%982021.pdf" target="_blank">支付宝(当面付)</a></li>
                            <li><a href="https://www.yuque.com/docs/share/41819185-84fa-42b3-a878-b901bccf11d2?#" target="_blank">自动提现到银行卡</a></li>
                             <li class="divider"></li>
                            <li class="dropdown-header">微信公众号</li>
                            <li><a href="http://kf.qq.com/" target="_blank">工资平台全套流程</a></li>
                            <li><a href="http://kf.qq.com/faq/120911VrYVrA130805byM32u.html" target="_blank">公众号类型</a></li>
                            <li><a href="https://shimo.im/docs/PVAPV2yGMvFmFVql/" target="_blank">吸粉机配置流程</a></li>
                            </div>
                        </ul>
                        </li>
                        <li @click="totop1()"> <router-link  to="/cooperation" >合作案例</router-link><img src="../../assets/rightline.png"></li>
                        <li @click="totop1()"> <router-link  to="/about" >关于我们</router-link></li>
                    </ul>
                </nav>
            </div>
        </div>
        
    </div>
     
     <!--登录-->
     <div class="big-log" v-show="logd2">
         <div class="content">
                <div class="poster"><img src="../login/images/poster.png" alt="" oncontextmenu="return false;" onselectstart="return false;"></div>
                <div class="logins">
                    <div class="login">
                        <div class="title">账号密码登录</div>
                        <div class="login-click">
                            <div class="agent" :class="{on:index==cur}" @click="changeOne(index)" v-for="(list,index) in lists" :key="index">{{list}}</div> 
                        </div>
                        <div class="input-bar">
                            <div class="account-bar">
                                <span class="account" v-show="account1">登录账号</span>
                                <input type="text" class="search-input" v-on:click="addAccount()" v-on:keyup="writeAccount()" @blur="showAccount()" v-model="input1">
                                <span class="noexist" v-show="noexist">账号不存在！</span>
                                <span class="delete" v-show="deletes" @click="hide()"><img src="../login/images/clear.png" alt=""></span>
                            </div>
                            <div class="password-bar">
                                <span class="account" v-show="account2">登录密码</span>
                                <input type="passWord" class="search-input" v-on:click="addPassword()" v-on:keyup='writePassword()' @blur='showPassword()' v-model="input2">
                                <span class="delete" v-show="deletes1" @click="hide1()"><img src="../login/images/clear.png" alt=""></span>
                            </div>
                        </div>
                        <div class="reads">
                            <div class="read">
                                <div class="check" ><img v-show="checkimg" src="../login/images/check.png" alt=""></div>
                                <span class="read-word">我已同意并已阅读<router-link tag="a" target="_blank" to="/agree" @click="showOne1">《维码器用户协议》</router-link></span>
                            </div>
                            <div class="forgot"><a href="">忘记密码</a></div>
                        </div>
                        <div class="enter" ref="bla" @click="enter()">登录</div>
                        <div class="change">切换<span class="phone" @click="change()">手机验证登录</span></div>
                    </div>

                    <!-- 手机验证码登录 -->
                    <div class="phone-verifi" :class="{ push : seen }">
                        <div class="title">手机验证登录</div>
                        <div class="login-click">
                            <div class="agent" :class="{on:index==cur}" @click="changeOne(index)" v-for="(list,index) in lists" :key="index">{{list}}</div>          
                        </div>
                        <div class="input-bar">
                            <div class="account-bar">
                                <span class="account" v-show="phoneNum1">手机号</span>
                                <input type="text" class="search-input" v-on:click="addNum()" @blur='showPhonenum()' v-model="input3" maxlength="11" @keyup="eleven()">
                                <span class="get"  @click="getCode2()" v-show="getCode3" v-text="d4" :style="d5"></span>
                                <span class="sixty" ref="sixty1" v-show="sixty3" ></span>
                            </div>
                            <div class="password-bar">
                                <span class="account" v-show="authcode">验证码</span>
                                <input type="text" class="search-input" v-on:keyup="addCode()" @blur='showAuthcode()' v-on:click='addAuthcode()' v-model="input4">
                                <span class="delete" v-show="deletes2" @click="hide2()"><img src="../login/images/clear.png" alt=""></span>
                            </div>
                        </div>
                        <div class="reads">
                            <div class="read">
                                <div class="check"><img v-show="checkimg1" src="../login/images/check.png" alt=""></div>
                                <span class="read-word">我已同意并已阅读<router-link tag="a" target="_blank" to="/agree" v-on:click="showOne2()">《维码器用户协议》</router-link></span>
                            </div>
                        </div>
                        <div class="enter" ref="bla1">登录</div>
                        <div class="change">切换<span class="phone" @click="change()">账号密码登录</span></div>
                    </div>
                </div>      
            </div> 
        <div class="logs" @click.stop="hideLogd2()" ></div>

    </div>
  </div>

</template>

<script>
import Log from '../login/log'
export default {
  name:'foot',
  components:{Log},
  data(){
      return{
          bars: [
        { list: '首页', image: require('../../assets/rightline.png'),link:'/home' },
        { list: '硬件产品', image: require('../../assets/rightline.png'),link:'/hard' },
        { list: '软件服务', image: require('../../assets/rightline.png'),link:'/software' },
        { list: '合作案例', image: require('../../assets/rightline.png'),link:'/cooperation' },
        { list: '关于我们', link:'/about' }   
      ],
      ok:false,
      logd2:false,
      nums: [
        {tel:'18773232030',name:'王生'},
        {tel:'18929539209',name:'李生'},
        {tel:'13539860650',name:'湛生'},
        {tel:'15659363555',name:'杨生'},
        {tel:'13822274256',name:'付生'}
        ],
      oldTime: (new Date("2018/04/23 00:00:00")).getTime(),
      timestamp: new Date().getTime(),

       reg : /^1[0-9]{10}$/,
           
        // flag : this.reg.test(phoneNum),
          seen:false,
          noexist:false,
          deletes:false,
          deletes1:false,
          deletes2:false,
          account1:true,
          account2:true,
          checkimg:true,
          checkimg1:true,
          authcode:true,
          phoneNum1:true,
          sixty3:false,
          getCode3:true,
          cur:0,
          lists:['商家登录','代理登录'],
          input1:'',
          input2:'',
          input3 : '',
          input4:'',
          d4: '获取验证码',
        // closeAgree:false,
        d5: {
            background:'',
            color:''
        },
        d6: true,
        showbg:true,
        isLog:true,
        d666: '',
        d555:''
      }
  },
  mounted(){
      var d = this.timestamp - this.oldTime;
        var week = 7*24*60*60*1000;
        var ns = Math.floor(d/week);
        var n = ns - (Math.floor(ns/5)*5);
        this.d555 = `${this.nums[n].tel}`
        this.d666 = `${this.nums[n].tel}`
  },
  methods:{
      backTop:function(){
         document.body.scrollTop = 0;          //仅仅设置 document.body 可能会有兼容性问题
        document.documentElement.scrollTop = 0
      },
      totop1:function(){
        document.body.scrollTop = 0;         
        document.documentElement.scrollTop = 0
      },
       btoggle:function(){
           this.logd2 = !this.logd2;
       },
       hideLogd2(){
        this.logd2 = !this.logd2;
       },


        change:function(){
          this.seen = !this.seen;
          this.account1 = true;
          this.account2 = true;
          this.authcode = true;
          this.phoneNum1 = true;
          this.input1 = '';
          this.input2 = '';
          this.input3 = '';
          this.input4 = '';
          this.deletes = false;
          this.deletes1 = false;
          this.deletes2 = false;
        //   this.checkimg = false;
        //   this.checkimg1 = false;
          this.$refs.bla.style.background = '#eaeaea';
          this.$refs.bla1.style.background = '#eaeaea';
          this.d5.background = '#f3f3f3';
      },
      changeOne(index){
          this.cur = index;
          this.account1 = true;
          this.account2 = true;
          this.authcode = true;
          this.phoneNum1 = true;
          this.input1 = '';
          this.input2 = '';
          this.input3 = '';
          this.input4 = '';
          this.deletes = false;
          this.deletes1 = false;
          this.deletes2 = false;
        //   this.checkimg = false;
        //   this.checkimg1 = false;
          this.$refs.bla.style.background = '#eaeaea';
          this.$refs.bla1.style.background = '#eaeaea';
           this.d5.background = '#f3f3f3';
      },
    //  键盘keyup
      writeAccount:function(){
          this.deletes = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
      writePassword:function(){
          this.deletes1 = true;
          //this.input2 = this.input2.replace(/./g,'*');  //无法显示他本来的值，你需要在另外的地方保存他的真实密码.
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
      addAccount:function(){
          this.account1 = false;
      },
      addPassword:function(){
           this.account2 = false;
      },
    //   点击删除账号
       hide:function(){
          this.input1 = '',
          this.deletes = !this.deletes;
          this.account1 = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
    //   点击删除密码
      hide1:function(){
          this.input2 = '',
          this.deletes1 = !this.deletes1;
          this.account2 = true;
          if(this.input1 !== '' && this.input2 !== ''){
              this.$refs.bla.style.background = '#198bfe';
          }else{
              this.$refs.bla.style.background = '#eaeaea';
          }
      },
    //   点击手机号码输入框的时候手机号码几个字隐藏
    addNum:function(){
        this.phoneNum1 = false;
        
    },
    //  验证码 键盘keyup
      addCode:function(){  
              this.deletes2 = true;
              if(this.input3 !== '' && this.input4 !== ''){
                    this.$refs.bla1.style.background = '#198bfe';
                }else{
                    this.$refs.bla1.style.background = '#eaeaea';
                }
      },
    //   点击input框的时候验证码几个字隐藏
     addAuthcode:function(){
         this.authcode = false;
    },
    //   点击手机验证的delete
      hide2:function(){
          this.input4 = '';
          this.deletes2 = false;
          this.authcode = true;
      },
      showAccount:function(){
          this.account1 = true;
      },
      showPassword:function(){
          this.account2 = true;
      },
      showPhonenum:function(){
          this.phoneNum1 = true;
      },
      showAuthcode:function(){
          this.authcode = true;
      },
      showOne1:function(){
         // this.$router.push({path:'/agree',})
      },
      showOne2:function(){
          //this.$router.push({path:'/agree',})
      },
    //   closeOne:function(){
    //       this.closeAgree = false;
    //   },
    //   手机号码正则判断
    eleven(){
        if(this.reg.test(this.input3) == true){
            // this.d5 = 'background:#198bfe';
            this.d5.background = '#198bfe';
            this.d5.color = '#fff';
            this.d6 = true;
        }else{
            this.d5.background = '#f3f3f3';
            this.d5.color = '#333';
            this.d6 = false;
        };
        if(this.input3.length == 11 && this.input4 == '' && this.reg.test(this.input3) == true){
            this.d6 = true;
        }

    },
    //点击获取验证码
    getCode2(){
        let that = this;  
        if(this.input3.length !== 11 && this.input4 == ''){
            this.d6 = false;
        }
       if(this.input3.length == 11 && this.input4 == '' && this.reg.test(this.input3) == true){
            this.d6 = true;
        }
        if (this.d6){
            var sum = 2;
            this.d6 =false;
            var timer = setInterval(function(){
            that.d5.background = '#f3f3f3';
            that.d5.color = '#333';
            that.d4 = sum + 's';    
            sum--;
            if(sum <0 ) {
                clearInterval(timer);
               that.d4 = '获取验证码';
               that.d5.background = '#198bfe';
               that.d5.color = '#fff';
               this.d6 = true;
            }
        },1000)
        }else{
        }
    },
    //登录
    enter(){
        if(this.$refs.bla1.style.background = '#eaeaea'){
            this.isLog = false;alert('请填写信息')
        }else{
            this.isLog = true;alert('登录')
        }
    }
  },

}
</script>

<style scoped>
/* .bottom-foot .big-log{
    margin-top: -10px;
} */
.phone-up{
    display: none;
}
.foots{
    width: 100%;
    height: 410px;
    background-color: #222222;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.top{
    top: -36px;
    width: 1200px;
    position: relative;
}
.top img{
    width: 80px;
	height: 80px;
    cursor: pointer;
}
.up{
    display: flex;
    justify-content: center;
    align-items: center;
}
.middle{
    width: 1200px;
   display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -56px;
}
.left p:nth-child(1){
    font-size: 16px;
	letter-spacing: 0px;
	color: #ffffff;
    font-family: 微软雅黑;
}
.left p:nth-child(2){
    font-size: 12px;
	letter-spacing: 0px;
	color: #ffffff;
    font-family: Arial;
}
.navs{
        margin-top: 44px;
}
.navs li a.tel{
    color: #fff;
    font-size: 20px;
    font-family: number-webfont;
}
.navs li{
    font-family: 微软雅黑;
    font-size: 14px;
	font-weight: normal;
	letter-spacing: 0px;
	color: #999999;
    line-height: 25px;
}
.navs li:nth-child(3){
    width: 420px;
	height: 1px;
	background-color: #333333;
    margin:24px 0px;
}
.foots .right{
    width: 160px;
    height: 215px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
}
.foots .right .ewm{
    width: 160px;
    height: 215px;
    cursor: pointer;
        display: flex;
    flex-direction: column;
    align-items: center;
}
.scan{
    color: #333;
    font-size: 16px;
    width: 122px;
    height: 37px;
    line-height: 37px;
    border-radius: 3px;
    background: #fff;
    text-align: center;
    font-family: 微软雅黑;
    /* display: none; */
    position: relative;
}
.scan::after{
    content: '';
    position: absolute;
    top: -4px;
    left: 55px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-bottom: 5px solid #fff;
    border-right: 5px solid transparent;
}
/* .foots .right .ewm:hover .scan{
    display: block;
} */
.right .icons{
    width:160px;
    height: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.right .icons>li{
    position: relative;
    cursor: pointer;
}
.icons img{
    width: 30px;
height: 30px;
}
.liphone{
position: absolute;
top: -120px;
left: -62px;
width: 160px;
text-align: center;
background: #fff;
color: #333;
padding: 20px 0px;
display: none;
}
 .liph{
  font-size: 14px;
  color: #333;
  margin-bottom: 10px;
}
 .liph1{
  color: #198bfe;
    font-weight: bold;
  font-size: 16px;
  display: block;
}
.liphone::after{
content: '';
position: absolute;
  top: 100px;
  left: 73px;
width: 0;
height: 0;
border-left: 5px solid transparent;
border-top: 5px solid #fff;
border-right: 5px solid transparent;
}

.right .icons li:nth-child(3):hover .liphone{
display: block;
}
.down{
    width:100%;
    height: 90px;
    background-color: #191919;
     display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    bottom: 0;
}
.down .foot{
    width:1200px;
    height: 90px;
     display: flex;
    justify-content: space-between;
    align-items: center;
}
.foot nav .nav{
    display: flex;
}
.copyright,nav .nav>li>a{
    font-family: 微软雅黑;
    font-size: 14px;
	color: #999999;
}
nav .nav>li a:hover{
    color: #198bfe;
}
.copyright{
        white-space:nowrap;
    }
nav .nav>li{
    width: 100px;
     height: 90px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    cursor: pointer;
}
@media screen and (max-width:1200px){
    .top,.middle,.down .foot{
        width:900px;
    }
    nav .nav>li{
        width: 80px;
    }
    .fa.fa.fa-caret-up{
        margin-left: -6px;
    }
}

/* 手机 */
@media screen and (max-width:768px){
.foots .top,.foots .up,.foots .down nav{
    display: none;
}
.bottom-foot{
    width: 100%;
}
.phone-up{
    display: block;
    width: 100%;
    padding: 0px 15px;
    box-sizing: border-box;
    margin-top: 5px;
}
.foots{
    width: 100%;
    height: 213px;
}
.phone-up .middle{
    margin-top: 0px;
    align-items: flex-end;
    width: 100%;
}
.longline{
    width: 100%;
    height: 1px;
    background: #333;
    margin: 3% 0px;
}
.foots .ewm{
    width: 52px;
    height: 52px;
}
.foots .left{
    margin-top: 3%;
}
.foots .ewm img{
    width: 100%;
}
.left p:nth-child(1){
    font-size: 9px;
}
.left p:nth-child(2){
    font-size: 7px;
    color:#999;
}
.bot p{
    font-size: 9px;
    color: #999;
    line-height: 16px;
}
.navs li a,a.tel10{
    color: #fff;
    font-size: 13px;
}
.navs{
    margin-top: 7%;
}
.navs li{
    font-size: 9px;
    line-height: 16px;
}
.down{
    width: 100%;
    height: 40px;
}
.down .foot{
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
        padding: 0px 15px;
    box-sizing: border-box;
}
.foot .copyright{
    font-size: 9px;
    white-space:nowrap;
}
}
@media screen and (max-width:320px){
    .foot .copyright{
    transform: scale(0.87);
}
}

/*登录*/
.input-bar{
    margin-top: -30px;
}
.big-log{
     width:100%;
     height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    /* margin-top: -80px; */
    z-index: 99;
    position: fixed;
    top: 0;
}
.logs{
    width:100%;
    height: 100%;
    /* background: url(./images/bg.jpg) no-repeat; 
     background-size: cover; */
    z-index:99;
    position: fixed;
    background: black;
    opacity: .5;
}
.content{
    width:900px;
    height: 600px;
    display: flex;
    z-index: 100;
}
.logins{
    width:500px;
    height: 600px;
    overflow: hidden;
}
.login,.phone-verifi{
    width:500px;
    height: 600px;
    background: #fff;
    border-radius: 0px 10px 10px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
}
.login .title,.phone-verifi .title{
    font-size: 34px;
	font-family: 微软雅黑;
	letter-spacing: 2px;
    color: #333333;
    font-weight: bold;
}
.login-click{
    width: 424px;
	height: 58px;
	background-color: #f0f0f0;
	border-radius: 10px;
    display: flex;
    align-items: center;
}
.login-click .agent.on{
    width: 210px;
	height: 54px;
	background-color: #ffffff;
	border-radius: 10px;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
    font-size: 16px;
    font-family: 微软雅黑;
    color: #999999;
    margin-left: 2px;
}
.login-click .agent{
    width: 210px;
	height: 54px;
	background-color: #f0f0f0;
	border-radius: 10px;
    text-align: center;
    line-height: 54px;
    cursor: pointer;
    font-size: 16px;
    font-family: 微软雅黑;
    color: #333;
}
.account-bar,.password-bar{
    width: 408px;
	height: 74px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #f0f0f0;
}
.account-bar .search-input,.password-bar .search-input{
    flex: 1;
    border: 0px;
    outline:none;
    margin-left: 10px;
    font-size: 14px;
    height: 65px;
    line-height: 65px;
}
.delete{
    cursor: pointer;
}
.account{
    font-size: 14px;
    color: #333;
    font-family: 微软雅黑;
}
.noexist{
    font-size: 14px;
    color: #ff6262;
    font-family: 微软雅黑;
}
.reads{
    width: 408px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: -26px;
}
.read{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.read .check{
    width: 16px;
	height: 16px;
	border-radius: 2px;
	border: solid 1px #f0f0f0;
    /* background: url(./images/check.png) no-repeat;
    background-size: cover; */
    margin-right: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}
.read .read-word{
    font-size: 14px;
    font-family: 微软雅黑;
    color: #333;
}
.read .read-word a{
    color: #198bfe;
    cursor: pointer;
}
.reads .forgot a{
    font-size: 14px;
    color: #999999;
    font-family: 微软雅黑;
    cursor: pointer;
}
.enter{
    width: 408px;
	height: 56px;
    line-height: 56px;
	background: #eaeaea;
	border-radius: 6px;
    font-family: 微软雅黑;
    text-align: center;
    color: #fff;
    cursor: pointer;
    margin-top: -22px;
}
.change{
    font-size: 14px;
    font-family: 微软雅黑;
    color: #999;
    margin-bottom: 30px;
}
.change .phone{
    color: #333;
    cursor: pointer;
}
.phone-verifi .account-bar .get{
    width: 88px;
	height: 32px;
    line-height: 32px;
	background: #f3f3f3;
    /* background: #198bfe; */
	border-radius: 6px;
    font-size: 14px;
    font-family: 微软雅黑;
    /* color: #999; */
    color: #333;
    text-align:center;
    cursor: pointer;
}
.phone-verifi .account-bar .sixty{
     width: 88px;
	height: 32px;
    line-height: 32px;
	background: #198bfe;
    /* background: #198bfe; */
	border-radius: 6px;
    font-size: 14px;
    font-family: 微软雅黑;
    /* color: #999; */
    color: #fff;
    text-align:center;
    cursor: pointer;
}
.phone-verifi.push{
    transform: translateY(-100%);
    z-index:9;
}

/* 产品手册 */
.nav li.books{
  position: relative;
  top:0px;
  left: 0px;
}
.books .book{
        width: 100px;
    display: flex;
    justify-content: space-around;
    align-items: center;
}
.books .book a{
    font-family: 微软雅黑;
    font-size: 14px;
    color: #999999;
}
.fa.fa-caret-up{
  color: #999;
    font-size: 14px;
  margin-left: -12px;
}
.books .dropdown-menu{
  width: 500px;
  height: 500px;
  position: absolute;
bottom: 80px;
left: -200px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  visibility: hidden;
}
.nav li.books:hover .dropdown-menu{
  visibility: visible;
  /* animation: 0.5s div ease-in forwards;  */
}
/* @keyframes div{
0%{height: 10px; }
100%{height: 500px; }
} */
.nav li.books:hover .dropdown-menu li{
  transition-delay: 0.15s;
}
.books .dropdown-menu li{
  width:200px;
  height: 30px;
  line-height: 30px;
  
}
.books .dropdown-menu .dropdown-header{
  font-size: 14px;
  font-family: 微软雅黑;
  color: #333;
}
.dropdown-menu li a{
  width:200px;
  height: 30px;
  color: #68747f;
  font-size: 14px;
  font-family: 微软雅黑;
  display: flex;
}
.dropdown-menu li a:hover{
  color: #198bfe;
}
.dropdown-menu li.divider{
  width: 210px;
  height: 1px;
  background: rgba(161, 166, 171, .2);
  margin: 20px 0px;
}
.dropdown-menu .dropdown-left,.dropdown-menu .dropdown-right{
  width: 210px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
      margin-top: 44px;
}
.books .dropdown-menu::after{
  content: '';
position: absolute;
bottom: -5px;
left: 230px;
width: 0;
height: 0;
border-left: 10px solid transparent;
border-top: 5px solid #fff;
border-right: 10px solid transparent;
}
.nav li.books:hover .book a,.nav li.books:hover .fa.fa-caret-up{
  color: #198bfe;
  cursor: pointer;
}
@media screen and (max-height: 800px){
.content{
        transform: scale(0.78);
    }
}
</style>





// WEBPACK FOOTER //
// src/components/hardProduct/foot.vue